import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/userhead.png';
import _imports_1 from '@/assets/img/write.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-714b6d6f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "window"
};
var _hoisted_2 = {
  class: "flex flex_between"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_4 = {
  class: "content_box"
};
var _hoisted_5 = {
  class: "box",
  style: {
    "padding-bottom": "0"
  }
};
var _hoisted_6 = {
  class: "special"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 难事类型: ", -1);
});

var _hoisted_8 = {
  class: "value"
};
var _hoisted_9 = {
  class: "special",
  style: {
    "color": "#597fca"
  }
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 上报街道: ", -1);
});

var _hoisted_11 = {
  class: "value"
};
var _hoisted_12 = {
  class: "special"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 联系人: ", -1);
});

var _hoisted_14 = {
  class: "value"
};
var _hoisted_15 = {
  class: "special"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 联系方式: ", -1);
});

var _hoisted_17 = {
  class: "value"
};
var _hoisted_18 = {
  key: 0,
  class: "special"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 开始时间: ", -1);
});

var _hoisted_20 = {
  class: "value"
};
var _hoisted_21 = {
  key: 1,
  class: "special"
};

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 预计结束时间: ", -1);
});

var _hoisted_23 = {
  class: "value"
};
var _hoisted_24 = {
  key: 2,
  class: "special"
};

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 投票结束时间: ", -1);
});

var _hoisted_26 = {
  class: "value"
};
var _hoisted_27 = {
  class: "special"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 问题描述: ", -1);
});

var _hoisted_29 = {
  class: "value"
};
var _hoisted_30 = {
  class: "special",
  style: {
    "margin-bottom": "0"
  }
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, " 描述图片: ", -1);
});

var _hoisted_32 = {
  key: 0,
  class: "value"
};
var _hoisted_33 = {
  key: 1
};
var _hoisted_34 = {
  key: 0,
  class: "box"
};
var _hoisted_35 = {
  class: "flex flex_between"
};

var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "self_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label_title"
  }, "跟进记录")], -1);
});

var _hoisted_37 = {
  key: 0,
  class: "flex"
};
var _hoisted_38 = {
  key: 0
};
var _hoisted_39 = {
  class: "progress_box"
};
var _hoisted_40 = {
  class: "icon"
};
var _hoisted_41 = {
  key: 0,
  class: "line"
};
var _hoisted_42 = {
  style: {
    width: '100%'
  }
};
var _hoisted_43 = {
  class: "title"
};
var _hoisted_44 = {
  class: "state"
};
var _hoisted_45 = {
  class: "time"
};
var _hoisted_46 = {
  class: "details"
};
var _hoisted_47 = {
  class: "content"
};
var _hoisted_48 = {
  key: 0,
  class: "handle_imgbox"
};
var _hoisted_49 = {
  key: 0,
  class: "headIcon",
  src: _imports_0
};
var _hoisted_50 = ["src"];
var _hoisted_51 = {
  class: "supervise_box"
};
var _hoisted_52 = {
  class: "supervise flex"
};
var _hoisted_53 = {
  class: "user_name"
};
var _hoisted_54 = {
  class: "supervise_time"
};
var _hoisted_55 = {
  class: "supervise supervise_content"
};
var _hoisted_56 = ["onClick"];

var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "write_icon",
    src: _imports_1
  }, null, -1);
});

var _hoisted_58 = /*#__PURE__*/_createTextVNode(" 填写监督 ");

var _hoisted_59 = [_hoisted_57, _hoisted_58];
var _hoisted_60 = {
  key: 0,
  class: "vote"
};
var _hoisted_61 = {
  class: "dialog-footer"
};

var _hoisted_62 = /*#__PURE__*/_createTextVNode(" 提交 ");

var _hoisted_63 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "确定完成本次帮扶？", -1);
});

var _hoisted_64 = {
  class: "dialog-footer"
};

var _hoisted_65 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_66 = /*#__PURE__*/_createTextVNode("确定");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_image = _resolveComponent("el-image");

  var _component_Vote = _resolveComponent("Vote");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    title: "难事上报"
  }), _createElementVNode("div", {
    class: "back",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.back && _ctx.back.apply(_ctx, arguments);
    })
  }, [_hoisted_3, _createVNode(_component_el_icon, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_ArrowRight, {
        color: "#c62423"
      })];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.detail.typeName), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.detail.street), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.detail.personName), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.detail.mobile), 1)]), _ctx.detail.startTime ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.detail.startTime), 1)])) : _createCommentVNode("", true), _ctx.detail.planTime ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.detail.planTime), 1)])) : _createCommentVNode("", true), _ctx.detail.voteEndTime ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.detail.voteEndTime), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.detail.description), 1)]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _ctx.detail.imgUrls ? (_openBlock(), _createElementBlock("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.imgUrls.split(','), function (item, index) {
    return _openBlock(), _createBlock(_component_el_image, {
      key: index,
      class: "special_image",
      src: _ctx.baseUrl + item,
      "preview-src-list": _ctx.previewImgList(_ctx.detail.imgUrls),
      "initial-index": index,
      fit: "cover",
      "z-index": "99999"
    }, null, 8, ["src", "preview-src-list", "initial-index"]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_33, " 无 "))])]), _ctx.detail.state != 2 && [4, 5].includes(_ctx.detail.status) ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _ctx.detail.identity == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", {
    class: _normalizeClass(["btn_item btn1", {
      'disabled_btn1': _ctx.detail.status != 4
    }]),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.toProgress(_ctx.detail.id, false);
    })
  }, " 填写过程 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["btn_item btn2", {
      'disabled_btn2': _ctx.detail.status != 4
    }]),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.toProgress(_ctx.detail.id, true);
    })
  }, " 完成 ", 2)])) : _createCommentVNode("", true)]), !_ctx.detail.dealList || _ctx.detail.dealList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.detail.status == 5 ? '未填写跟进记录' : '暂无记录 ～'), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.dealList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "handle_process"
    }, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", {
      class: "spot",
      style: _normalizeStyle({
        background: item.isFinishProcess ? '#e01f20' : '#afb1bb'
      })
    }, null, 4), index != _ctx.detail.dealList.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_41)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(item.isFinishProcess ? "已解决" : index == _ctx.detail.dealList.length - 1 ? "已受理" : "事件动态" + (_ctx.detail.dealList.length - 1 - index)), 1), _createElementVNode("span", _hoisted_45, _toDisplayString(item.submitTime.split(" ")[0]), 1)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(item.dealContent), 1), item.imgUrls ? (_openBlock(), _createElementBlock("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgUrls.split(','), function (img, index) {
      return _openBlock(), _createBlock(_component_el_image, {
        key: img,
        class: "image",
        src: _ctx.baseUrl + img,
        "preview-src-list": _ctx.previewImgList(item.imgUrls),
        "initial-index": index,
        fit: "cover",
        "z-index": "99999"
      }, null, 8, ["src", "preview-src-list", "initial-index"]);
    }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.superviseList, function (supervise, index) {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "comments"
      }, [!supervise.headIcon ? (_openBlock(), _createElementBlock("img", _hoisted_49)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "headIcon",
        src: _ctx.baseUrl + supervise.headIcon
      }, null, 8, _hoisted_50)), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, _toDisplayString(supervise.superviserName), 1), _createElementVNode("div", _hoisted_54, _toDisplayString(supervise.submitTime), 1)]), _createElementVNode("div", _hoisted_55, _toDisplayString(supervise.content), 1)])]);
    }), 128)), _ctx.detail.identity == 2 && _ctx.detail.status == 4 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "comments_btn",
      onClick: function onClick($event) {
        return _ctx.setSupervision(item);
      }
    }, _hoisted_59, 8, _hoisted_56)) : _createCommentVNode("", true)])])]);
  }), 128))])])) : _createCommentVNode("", true)]), _ctx.detail.status == 5 && _ctx.detail.state != 2 && _ctx.detail.processStatus != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createVNode(_component_Vote, {
    row: _ctx.detail,
    satisfied: _ctx.cacheData.satisfied,
    dissatisfied: _ctx.cacheData.dissatisfied,
    onVoteSubmit: _ctx.init
  }, null, 8, ["row", "satisfied", "dissatisfied", "onVoteSubmit"])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: _ctx.ishide,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.ishide = $event;
    }),
    "destroy-on-close": "",
    title: "立刻监督",
    width: "464px",
    style: {
      "border-radius": "12px"
    },
    onClose: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.close();
    })
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_61, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.submit
      }, {
        default: _withCtx(function () {
          return [_hoisted_62];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_input, {
        modelValue: _ctx.cacheData.content,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _ctx.cacheData.content = $event;
        }),
        class: "dealContent",
        placeholder: "",
        maxlength: "100",
        "show-word-limit": "",
        resize: "none",
        "input-style": {
          height: '100px'
        },
        type: "textarea"
      }, null, 8, ["modelValue"])];
    }),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return _ctx.show = $event;
    }),
    title: "提示",
    width: "30%",
    draggable: ""
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_64, [_createVNode(_component_el_button, {
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return _ctx.show = false;
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_65];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.confirm
      }, {
        default: _withCtx(function () {
          return [_hoisted_66];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    default: _withCtx(function () {
      return [_hoisted_63];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}